var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCirclesThreePlus = function SvgIconCirclesThreePlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.75 6.938a4.188 4.188 0 1 1 8.375 0 4.188 4.188 0 0 1-8.375 0M6.938 4.75a2.188 2.188 0 1 0 0 4.375 2.188 2.188 0 0 0 0-4.375M12.875 6.938a4.187 4.187 0 1 1 8.375 0 4.187 4.187 0 0 1-8.375 0m4.188-2.188a2.188 2.188 0 1 0 0 4.375 2.188 2.188 0 0 0 0-4.375M6.938 12.875a4.187 4.187 0 1 0 0 8.375 4.187 4.187 0 0 0 0-8.375M4.75 17.063a2.188 2.188 0 1 1 4.375 0 2.188 2.188 0 0 1-4.375 0",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.063 13.625a1 1 0 0 1 1 1v1.438H19.5a1 1 0 1 1 0 2h-1.437V19.5a1 1 0 1 1-2 0v-1.437h-1.438a1 1 0 1 1 0-2h1.438v-1.438a1 1 0 0 1 1-1"
  }))));
};
export default SvgIconCirclesThreePlus;